const request = (state = { isProcessing: false }, action) => {
  switch (action.type) {
    case 'PROCESSING_REQUEST_START':
      return {
        ...state,
        isProcessing: true,
      };
    case 'PROCESSING_REQUEST_END':
      return {
        ...state,
        isProcessing: false,
      };
    default:
      return state;
  }
};

export default request;
